// extracted by mini-css-extract-plugin
module.exports = {"addCardForm":"styles_addCardForm__1ASUP","makeDefault":"styles_makeDefault__2sX6s","buttons":"styles_buttons__3tBNG","spinner":"styles_spinner__RLe63"};